var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ExternalServiceClientPanel',{attrs:{"facility":_vm.facility}}),_c('ExternalServiceRoomadmin',{attrs:{"facility":_vm.facility}}),_c('ExternalServiceMeteorSites',{attrs:{"facility":_vm.facility}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }